import "@formatjs/intl-numberformat/polyfill";
import "@formatjs/intl-numberformat/locale-data/en";
import "intersection-observer";
import { Fragment, render } from "preact";
import { StrictMode } from "preact/compat";
import ReactModal from "react-modal";
import AppContainer from "~/app/app-container.tsx";
import initMonitoring from "@brickme/frontend-common/src/monitoring/init-monitoring.ts";
import { initialiseGtm, createStubGtm } from "~/frontend-common/gtm.ts";
import PasswordProtected from "~/frontend-common/password-protected/index.tsx";
import { ensureEnv, optionalEnv } from "~/utils/env";
import packageInfo from "../package.json";
import "@brickme/frontend-common/src/ui/styles/ui-global.css";
import "@brickme/frontend-common/src/utils/validation-config.ts";
import "~/assets-new/sass/main.sass";

initMonitoring({
	sentryDsn: optionalEnv("SENTRY_DSN"),
	sentryEnvironment: optionalEnv("SENTRY_ENVIRONMENT"),
	number: packageInfo.version,
	commitId: ensureEnv("VERSION_ID"),
	buildTimestamp: ensureEnv("BUILD_TIMESTAMP"),
});

if (!(window as any).ResizeObserver) {
	(async () => {
		(window as any).ResizeObserver = (
			await import("resize-observer-polyfill")
		).default;
	})();
}

ReactModal.setAppElement("#root");

const shopifyCustomDomain = ensureEnv("SHOPIFY_SHOP_DOMAIN");
const shopifyStorefrontAccessToken = ensureEnv("STOREFRONT_ACCESS_TOKEN");
const userPoolId = ensureEnv("USER_POOL_ID");
const userPoolAppClientId = ensureEnv("USER_POOL_APP_CLIENT_ID");
const apiUrl = ensureEnv("API_URL");
const platformCookieDomain = ensureEnv("PLATFORM_COOKIE_DOMAIN");
const creatorAppUrl = ensureEnv("CREATOR_APP_URL");
const websiteUrl = ensureEnv("WEBSITE_URL");
const gorgiasId = optionalEnv("GORGIAS_ID");

const contactEmailAddress = ensureEnv("CONTACT_EMAIL_ADDRESS");
const ipInfoToken = ensureEnv("IP_INFO_TOKEN");
const domain = ensureEnv("DOMAIN");
const facebookAppId = optionalEnv("FACEBOOK_APP_ID");
const brandId = ensureEnv("BRANDING_ID");

const PossiblePasswordProtected = optionalEnv("PROTECTED_PASSWORD")
	? PasswordProtected
	: Fragment;

const gtmId = optionalEnv("GTM_ID");
const gtmServerDomain = optionalEnv("GTM_SERVER_DOMAIN");
const gtm =
	gtmId && gtmServerDomain
		? initialiseGtm({ id: gtmId, gtmServerDomain })
		: createStubGtm();

function Root() {
	return (
		<StrictMode>
			<PossiblePasswordProtected>
				<AppContainer
					brandId={brandId}
					originSite={ensureEnv("SITE_CODE")}
					contactEmailAddress={contactEmailAddress}
					gtm={gtm}
					ipInfoToken={ipInfoToken}
					creatorAppUrl={creatorAppUrl}
					websiteUrl={websiteUrl}
					shopifyConfig={{
						customDomain: shopifyCustomDomain,
						storefrontAccessToken: shopifyStorefrontAccessToken,
					}}
					userPoolConfig={{
						id: userPoolId,
						appClientId: userPoolAppClientId,
					}}
					// countryRedirectRules={countryRedirectRules}
					// defaultCountryCode={defaultCountryCode}
					apiUrl={apiUrl}
					platformCookieDomain={platformCookieDomain}
					gorgiasId={gorgiasId}
					domain={domain}
					facebookAppId={facebookAppId}
				/>
			</PossiblePasswordProtected>
		</StrictMode>
	);
}

const rootElement = document.getElementById("root");
if (rootElement === null) {
	throw new Error(`Couldn't find root element`);
}
render(<Root />, rootElement);
